import React, { Component } from 'react';

class EmptyGraph extends Component {
  render() {
    return (
      <div className="EmptyGraph">
        Error! Data not provided from source!
      </div>
    );
  }
}

export default EmptyGraph;
